import { init, configureScope } from '@sentry/browser';
import WixSDK from 'shared/utils/wix-sdk';

export const setupSentryForDesktop = () =>
  setupSentry('https://69a0c64f3a7a49068e33269efa2132f2@sentry.io/1396506');
export const setupSentryForMobile = () =>
  setupSentry('https://f1e223feb65d4fe9ad0ce13ff4cceb12@sentry.io/1396509');

function setupSentry(dsn) {
  try {
    setup(dsn);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Unable to setup Sentry', e);
  }
}

function setup(dsn) {
  const { __DEBUG__, __CI_APP_VERSION__ } = window;

  init({
    dsn,
    release: __CI_APP_VERSION__,
    environment: __DEBUG__ ? 'development' : 'production',
  });

  configureScope(scope => {
    scope.setUser({
      id: WixSDK.Utils.getUid(),
    });
    scope.setExtra('biToken', WixSDK.Utils.getInstanceValue('biToken'));
    scope.setExtra(
      'compId',
      WixSDK.Utils.getOrigCompId() || WixSDK.Utils.getCompId(),
    );
    scope.setExtra('instanceId', WixSDK.Utils.getInstanceId());
    scope.setExtra('msid', WixSDK.Utils.getInstanceValue('metaSiteId'));
    scope.setTag('viewMode', WixSDK.Utils.getViewMode());
    scope.setTag('deviceType', WixSDK.Utils.getDeviceType());
  });
}
